type Props = {
  word: string
}
export const ShowMeaning = ({ word }: Props) => {
  return (
    <button
      type="button"
      className="inline-flex justify-center p-1 rounded-md border border-transparent shadow-sm bg-slate-100 text-base  text-slate-900 sm:text-sm"
    >
      <a
        href={`https://www.almaany.com/ar/dict/ar-ar/${word}/`}
        target="_blank"
        rel="noreferrer"
      >
        📖 &nbsp; تعرّف على معنى
        <b>
          <i>{` ${word} `}</i>
        </b>
      </a>
    </button>
  )
}
